import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

import type { ActionResponse, RejectRequestPayload } from '../types';

type ServiceUserEnvelope<T> = {
  message?: string;
  status?: string;
  responseBody?: T;
  errorCode?: number;
  errorMessage?: string | null;
};

const ENDPOINT = '/user/v1/trainer-slots/parent-connect/request/reject';

export const rejectParentConnectRequest = async (
  payload: RejectRequestPayload
): Promise<ActionResponse> => {
  const data: ServiceUserEnvelope<ActionResponse> = await axios.post(
    ENDPOINT,
    payload
  );
  return data?.responseBody ?? {};
};

export const rejectParentConnectRequestMockHandler = http.post(
  `${env.API_URL}${ENDPOINT}`,
  async ({ request }) => {
    await networkDelay();
    let sessionId = 'mock-session-id';
    try {
      const body = (await request.json()) as Partial<RejectRequestPayload>;
      if (body.session_id) {
        sessionId = body.session_id;
      }
    } catch {
      /* swallow - dev-only mock */
    }
    return HttpResponse.json<ServiceUserEnvelope<ActionResponse>>({
      status: 'SUCCESS',
      message: 'Parent-connect request rejected',
      errorCode: 0,
      errorMessage: null,
      responseBody: {
        session_id: sessionId,
        session_status: 'inactive',
      },
    });
  }
);
